import { GrayColor } from '@global/utils/ui/colors';

export const AnimationDuration = 200;
export const DefaultAlpha = '4D'; // 30%;
export const ScreenUnit = 'px';
export const DarkOverlayColor = GrayColor.GrayXDark + 'ao';
export const LightOverlayColor = GrayColor.White + 'ao';
export const FacebookColor = '#3B5998';
